import { useBoundActions } from '../../../../../../../../hooks/useBoundActions';
import { setJsonQueryPriceType } from '../../../../../../../state/json_query_price_type';

const actions = {
  setJsonQueryPriceType,
};

export function useCoworkingPriceTypeDropdownBoundActions() {
  return useBoundActions(actions);
}
